import { Tooltip, Typography, useTheme } from '@material-ui/core'
import clsx from 'clsx'

import { getTranslate } from '../../localization'
import { InventoryComparisonRow } from '../../types/inventoryHealth'
import LayerValue from './LayerValue'
import { formatComparisonDate } from './comparisonDate'
import { findingLabel, findingText, statusColor } from './findings'
import useStyles from './styles/InventoryHealthTable.styles'

export default function InventoryHealthRow({
  row
}: {
  row: InventoryComparisonRow
}) {
  const classes = useStyles()
  const isDark = useTheme().palette.type === 'dark'
  const flagged = row.findingCodes.length > 0

  return (
    <div
      className={clsx(
        classes.row,
        flagged ? classes.rowFlagged : classes.rowNormal
      )}
      role="row">
      <div role="cell">
        <Typography variant="body2">
          {formatComparisonDate(row.date)}
        </Typography>
      </div>
      <div role="cell">
        <Typography variant="body2">
          {row.roomTypeName || row.roomTypeCode}
        </Typography>
      </div>
      <div role="cell">
        <Typography variant="body2">
          {row.ratePlanName || row.ratePlanCode}
        </Typography>
      </div>
      <div role="cell">
        <Typography variant="body2">
          {row.channelName || row.channelID}
        </Typography>
      </div>
      <div role="cell">
        <LayerValue value={row.pms} />
      </div>
      <div role="cell">
        <LayerValue value={row.crs} />
      </div>
      <div role="cell">
        <LayerValue value={row.channel} />
      </div>
      <div role="cell" style={{ color: statusColor(row.status, isDark) }}>
        {!flagged
          ? getTranslate('Agrees')
          : row.findingCodes.map((code) => (
              <Tooltip key={code} title={findingText(code)}>
                {/*
                  tabIndex makes the explanation reachable by keyboard. A
                  Tooltip on a non-focusable element is mouse-only, failing
                  WCAG 2.1.1, and hides the sentence from anyone who never
                  thinks to hover.
                */}
                <Typography
                  variant="body2"
                  tabIndex={0}
                  aria-label={findingText(code)}
                  className={classes.findingChip}>
                  {findingLabel(code)}
                </Typography>
              </Tooltip>
            ))}
      </div>
    </div>
  )
}
